module.exports = __webpack_public_path__ + "img/internet-title.678cd5c7.jpg";